// extracted by mini-css-extract-plugin
export default {"switch-container":"styles_switch-container__5aUv3","switch-label":"styles_switch-label__6Ocfs"};